import { render, staticRenderFns } from "./GTINDetail.vue?vue&type=template&id=75b30147&scoped=true&"
import script from "./GTINDetail.vue?vue&type=script&lang=js&"
export * from "./GTINDetail.vue?vue&type=script&lang=js&"
import style0 from "./GTINDetail.vue?vue&type=style&index=0&id=75b30147&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75b30147",
  null
  
)

export default component.exports